import * as React from "react";
import { Route, RouteProps, useHistory } from "react-router-dom";
import { useAuthContext } from "../../auth-state";
import { AuthUtil } from "../../utils/auth";
import { DangerButton, WarningBanner } from "@graffer-inc/console-design-kit";
import { BrowserTemplate } from "../template/service-provider/default-template";

export const ServiceProviderRoute: React.FC<
  {
    component: React.ComponentType<any>;
  } & RouteProps
> = ({ component: Component, ...rest }) => {
  const history = useHistory();
  const authState = useAuthContext();

  const logoutTenantUser = async () => {
    await AuthUtil.logout();
    history.push("/service-provider/login");
    window.location.reload();
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authState.lastChecked) {
          return <div />;
        }

        if (!authState.isAuthed) {
          AuthUtil.toAdminLogin();
          return;
        }

        if (authState.data!.accountType === "GrafferStaffAccount") {
          return <Component {...props} />;
        }

        return (
          <BrowserTemplate>
            <div className="c-content-wrapper">
              <div
                className="columns is-centered is-vcentered"
                style={{
                  marginTop: "10rem",
                }}
              >
                <section>
                  <WarningBanner
                    message="現在テナントユーザーでログインしています"
                    description="サービスプロバイダーアカウントにログインするには、テナントユーザーからログアウトしてください"
                  />
                  <div className="has-text-centered mt-4">
                    <DangerButton
                      text={"テナントユーザーからログアウトする"}
                      onClick={logoutTenantUser}
                    />
                  </div>
                </section>
              </div>
            </div>
          </BrowserTemplate>
        );
      }}
    />
  );
};
